import React, { useLayoutEffect, useState } from "react";
import RPModal from "../../Modal/RPModal";
import { KlachtenValues } from "../../klantenregister";
import RpKlachtenRegisterForm from "../klachtenregister/RpKlachtenRegisterForm";
import { getKlacht, getStates } from "../../Localstorage/localstorage";
import { AXIOS_GET } from "../../server/api/crud";
import { faListCheck, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function KlachtenRegisterFormulier({ swipperRef, userdetails,user, navigation, onProgressUpdate }) {
  const [open, setOpen] = useState(false);
  const [klachten, setKlachten] = useState(null);
  const [state, setState] = useState(null);
  const [klacht, setKlacht] = useState(0);
  const klachtslocal = getKlacht();
  const status = getStates();

  useLayoutEffect(() => {
    let kl = {};
    let st = {};

    const fetchDataKlacht = async (id) => {
      try {
        const response = await AXIOS_GET(`klachtenregistratie/all/${id}`);
        // Loop through the object properties

        const dataKlachten = response?.data;
        let newKlacht = {};

        Object.entries(dataKlachten).map(([key, value]) => {
          let remove = key
            .replace("Data", "")
            .replace("ontlastingstoelgang", "ontlasting_stoelgang");
          if (value.length > 0) {
            newKlacht[remove] = value[0];
          } else {
            newKlacht[remove] = KlachtenValues(id)[remove];
          }
        });
        setKlachten(newKlacht);
      } catch (error) {
        setKlachten(KlachtenValues(id));
        console.error("Error fetching data:", error);
      }
    };

    const fetchdata = async () => {
      await AXIOS_GET(`klachtenregistratie/${userdetails?.user_id}`)
        .then((resklacht) => {
          if (resklacht.data.length > 0) {
            kl = resklacht.data[0];
            st = { id: resklacht.data[0]?.status };
            setKlacht(kl);
            setState(st);
            fetchDataKlacht(kl?.id);
          } else {
            setKlacht(klachtslocal);
            setState(status);
            fetchDataKlacht(klachtslocal?.id);
          }
        })
        .catch(() => {
          setState({ id: 0 });
          fetchDataKlacht(0);
        });
    };
    fetchdata();
  }, [getKlacht, getStates]);


  const tileBtn =
    "group relative mx-auto block w-full max-w-3xl rounded-2xl border-2 border-dashed border-wa-border bg-wa-panel2/35 px-6 py-10 text-center shadow-[0_20px_60px_-36px_rgba(0,0,0,0.45)] backdrop-blur-sm transition-colors hover:border-wa-accent/45 hover:bg-wa-panel2/55 focus:outline-none focus-visible:ring-2 focus-visible:ring-wa-accent/35 focus-visible:ring-offset-2 focus-visible:ring-offset-wa-app sm:px-10 sm:py-12";

  return (
    <div className="mt-10 flex justify-center px-3 sm:mt-16 sm:px-4">
      {klacht.status < 17 && klacht.status > 0 && klacht?.versturen == 0 ? (
        <button type="button" onClick={() => setOpen(true)} className={tileBtn}>
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-wa-accent/15 text-3xl text-wa-accent ring-1 ring-wa-accent/25">
            <FontAwesomeIcon icon={faListCheck} />
          </div>

          <span className="mt-4 block text-base font-semibold leading-snug text-wa-text sm:text-lg">
            Het klachtenformulier is al ingevuld. Wilt u nog aanpassingen maken?
            Klik hier.
          </span>
        </button>
      ) : klacht?.versturen == 1 ? (
        <button type="button" onClick={() => setOpen(true)} className={tileBtn}>
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-wa-accent/15 text-3xl text-wa-accent ring-1 ring-wa-accent/25">
            <FontAwesomeIcon icon={faPaperPlane} />
          </div>

          <span className="mt-2 block text-base font-semibold leading-snug text-wa-text sm:text-lg">
            Het klachtenformulier is ingevuld en verstuurd.
          </span>

          <span className="mt-3 block text-sm leading-relaxed text-wa-muted sm:text-base">
            Wilt u verder met de andere vragenlijsten? Ga dan naar de tab{" "}
            <span className="font-semibold text-wa-text">Stap 4: Voedingdagboek</span>.
          </span>
        </button>
      ) : (
        <button type="button" onClick={() => setOpen(true)} className={tileBtn}>
          <svg
            className="mx-auto h-14 w-14 text-wa-muted transition-colors group-hover:text-wa-accent"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 48 48"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 2H32C33.1 2 34 2.9 34 4V44C34 45.1 33.1 46 32 46H12C10.9 46 10 45.1 10 44V4C10 2.9 10.9 2 12 2Z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M10 2H24L34 12H10V2Z"
            />
          </svg>

          <span className="mt-4 block text-base font-semibold leading-snug text-wa-text sm:text-lg">
            Vul het klachtenregistratieformulier in door hier te klikken.
          </span>
        </button>
      )}
      <RPModal
        setOpen={setOpen}
        open={open}
        Component={
          <RpKlachtenRegisterForm
            setOpen={setOpen}
            setKlachten={setKlachten}
            klachten={klachten}
            status={state}
            klacht={klacht}
            onProgressUpdate={onProgressUpdate}
          />
        }
      />
    </div>
  );
}

export default KlachtenRegisterFormulier;
